export default __webpack_public_path__ + "static/media/einarson.1dd1f48f.jpg";